/* eslint-disable no-case-declarations */
import React, { Component } from "react";
import loader from "../loader.gif";
import logo from "../images.png";
import AcademicInterest from "./AcademicInterest";
//import GovernmentInformation from "./GovernmentInformation";
import PersonalInformation from "./PersonalInformation";
import Citizenship from "./Citizenship";
import MotivationLetter from "./MotivationLetter";
import Address from "./Address";
import Contact from "./Contact";
import ParentsInformation from "./ParentsInformation";
import GuardianInformation from "./GuardianInformation";
import ArabicInformation from "./ArabicInformation";
import Sources from "./Sources";
import Policies from "./Policies";
import PropTypes from "prop-types";
import EducationHistoryUndergraduate from "./EducationHistoryUndergraduate";
import EducationHistoryGraduate from "./EducationHistoryGraduate";
import { emailCheck } from "../constants";
import submit from "../submit.gif";
import TestScores from "./TestScores";
export default class Mains extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveProcessing: false,
      nextProcessing: false,
      acceptedPolicies: false,
      isBlocking: true,
      loading: true,
      program: "",
      nationality: 0,
      countryData: [],
      email: "",
      fname: "",
      lName: "",
      mName: "",
      letter: "",
      gender: 0,
      dateOfBirth: 0,
      motherInfo: [],
      fatherInfo: [],
      guardianInfo: [],
      sourceInfo: [],
      saved: false,
      count: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      sections: [
        {
          name: "Personal Information",
          open: false,
        },
        {
          name: "Contact Details",
          open: false,
        },
        {
          name: "Family / Guardian Information",
          open: false,
        },
        {
          name: "Address",
          open: false,
        },
        {
          name: "Citizenship Information",
          open: false,
        },
        {
          name: "Program of Study",
          open: false,
        },
        {
          name: "Emergency Contact",
          open: false,
        },
        {
          name: "Education",
          open: false,
        },
        {
          name: "Test Scores",
          open: false,
        },
        {
          name: "Relationship with LGU",
          open: false,
        },
        {
          name: "Official Information In Arabic",
          open: false,
        },
        {
          name: "Motivation Letter",
          open: false,
        },
        {
          name: "Acknowledgement",
          open: false,
        },
      ],
      activeSections: [
        {
          name: "Personal Information",
          open: false,
        },
        {
          name: "Contact Details",
          open: false,
        },
        {
          name: "Family / Guardian Information",
          open: false,
        },
        {
          name: "Address",
          open: false,
        },
        {
          name: "Citizenship Information",
          open: false,
        },
        {
          name: "Program of Study",
          open: false,
        },
        {
          name: "Emergency Contact",
          open: false,
        },
        {
          name: "Education",
          open: false,
        },
        {
          name: "Test Scores",
          open: false,
        },
        {
          name: "Relationship with LGU",
          open: false,
        },
        {
          name: "Official Information In Arabic",
          open: false,
        },
        {
          name: "Motivation Letter",
          open: false,
        },
        {
          name: "Acknowledgement",
          open: false,
        },
      ],
      incompleteApplicationId: 0,
      selectedProgram: 0,

      //Address
      addressType: 0,
      line1: "",
      line2: "",
      country: 0,
      city: 0,
      region: 0,
      regionInput: "",

      //Citizenship
      countryOfBirth: 0,
      cityOfBirth: 0,
      nationality: 0,
      otherNationality: 0,

      //siblingFName: "",
      //siblingMName: "",
      //siblingLName: "",
      //siblingTKHNumber: "",

      //Official Arabic Information
      arabicData: [],

      //Contact
      contactInformation: [],

      //Education
      educationHistory: [],

      //Academic Interest
      entryTerm: 0,
      selectedUniversity: 0,
      selectedMajor: 0,
      selectedSecondUniversity: 0,
      selectedSecondProgram: 0,
      selectedSecondMajor: 0,
      selectedSecondLanguage: 0,

      selectedThirdUniversity: 0,
      selectedThirdProgram: 0,
      selectedThirdMajor: 0,
      selectedThirdLanguage: 0,

      selectedLevel: 0,
      selectedSecondLevel: 0,
      programOfStudyId: "",
      description: "",
      secondDescription: "",
      undergraduate: null,
      graduate: null,

      //Government
      //nationalIdNumber: "",
      // passportNumber: "",
      // passportCountry: 0,
      // passportExpiry: "",

      //Source
      otherSource: null,
      selectedRelationType: "",
      selectedRelationStatus: "",
      selectedRelationFirstName: "",
      selectedRelationLastName: "",

      policyError: "",
      testTypeError: "",
      color: "red",
      personalInformation: {},

      citizenshipInformation: {},
      officialArabicInformation: {},
      errorPI: {},
      ai: {},
      errorAI: {},
      governmentInformation: {},
      errorGI: {},
      address: {},
      errorAdd: {},
      errorCIT: {},
      errorOIA: {},
      contactInformations: {},
      errorContact: {},
      parentsInformation: {},
      errorParent: {},
      guardianInformation: {},
      errorGuard: {},
      educationHistorys: {},
      errorEdu: {},
      testScores: {},
      testScoresProp: {},
      errorTest: [],
      errorAcad: {},
      healthInformation: {},
      errorHI: {},
      sources: [],
      errorSources: {},
      sourceInfo: {},
      sourceInformation: {},
      fatherId: null,
      motherId: null,
      ahsd: null,
      ib: null,
      anata: null,
      igcse: null,
      gcse: null,
      isFoundation: false,
      isPopup: false,
      preferredCampus: "",
      dormPlanInterest: false,
    };
    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.collectState = this.collectState.bind(this);
    this.prepareState = this.prepareState.bind(this);
    this.conditionCheck = this.conditionCheck.bind(this);
    this.personalInformationCheck = this.personalInformationCheck.bind(this);
    this.educationHistoryCheck = this.educationHistoryCheck.bind(this);
    this.academicInterestCheck = this.academicInterestCheck.bind(this);
    this.addressCheck = this.addressCheck.bind(this);
    this.contactCheck = this.contactCheck.bind(this);
    this.parentsInformationCheck = this.parentsInformationCheck.bind(this);
    this.guardianInformationCheck = this.guardianInformationCheck.bind(this);
    this.testScoresCheck = this.testScoresCheck.bind(this);
    this.sourcesCheck = this.sourcesCheck.bind(this);
    this.citizenshipCheck = this.citizenshipCheck.bind(this);
    //this.governmentInformationCheck =this.governmentInformationCheck.bind(this);
    //this.healthInformationCheck = this.healthInformationCheck.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.submit = this.submit.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
    this.changeFoundation = this.changeFoundation.bind(this);
    this.changePopup = this.changePopup.bind(this);
  }

  async componentDidMount() {
    this.setState({
      incompleteApplicationId:
        parseInt(this.props.incompleteApplicationId) ||
        parseInt(sessionStorage.getItem("id")),
      token:
        this.props.token ||
        sessionStorage.getItem("token") ||
        sessionStorage.getItem("token"),
    });
    fetch(`${process.env.REACT_APP_API_URL}/api/login/getprefilleddata`, {
      method: "POST",
      body: JSON.stringify({
        IncompleteApplicationId:
          this.props.incompleteApplicationId ||
          parseInt(sessionStorage.getItem("id")),
        Token:
          this.props.token ||
          sessionStorage.getItem("token") ||
          sessionStorage.getItem("token"),
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200) {
          this.setState({
            //Motivation Letter
            letter: res.data.Letter,

            /* Personal Information */
            fName: res.data.FirstName,
            lName: res.data.LastName,
            mName: res.data.MiddleName,
            email: res.data.Email,
            dateOfBirth: res.data.DateOfBirth,
            countryOfBirth: res.data.CountryOfBirth,
            nationality: res.data.Nationality,
            cityOfBirth: res.data.CityOfBirth,
            otherNationality: res.data.OtherNationality,
            gender: res.data.Gender,

            //Official Information Arabic
            arabicData: res.data.ArabicData,

            // siblingFName: res.data.SiblingFName,
            // siblingMName: res.data.SiblingMName,
            // siblingLName: res.data.SiblingLName,
            // siblingTKHNumber: res.data.SiblingTKHNumber,

            officialArabicInformation: {
              arabicText1:
                res.data.ArabicData && res.data.ArabicData.length >= 1
                  ? res.data.ArabicData[0].ColumnValue
                  : "",
              arabicText2:
                res.data.ArabicData && res.data.ArabicData.length >= 2
                  ? res.data.ArabicData[1].ColumnValue
                  : "",
              arabicText3:
                res.data.ArabicData && res.data.ArabicData.length >= 3
                  ? res.data.ArabicData[2].ColumnValue
                  : "",
              arabicText4:
                res.data.ArabicData && res.data.ArabicData.length >= 4
                  ? res.data.ArabicData[3].ColumnValue
                  : "",
              arabicText5:
                res.data.ArabicData && res.data.ArabicData.length >= 5
                  ? res.data.ArabicData[4].ColumnValue
                  : "",
            },
            citizenshipInformation: {
              selectedCountry: res.data.CountryOfBirth,
              selectedNationality: res.data.Nationality,
              selectedOtherNationality: res.data.OtherNationality,
              cityOfBirth: res.data.CityOfBirth,
            },
            personalInformation: {
              dateOfBirth: res.data.DateOfBirth,
              fName: res.data.FirstName,
              lName: res.data.LastName,
              mName: res.data.MiddleName,
              selectedGender: res.data.Gender,
              // siblingFName: res.data.SiblingFName,
              // siblingMName: res.data.SiblingMName,
              // siblingLName: res.data.SiblingLName,
              // siblingTKHNumber: res.data.SiblingTKHNumber,
            },
            /* Contact Information */
            contactInformation: res.data.ContactInformation,
            /* Program of Study */
            selectedProgram: res.data.ProgramId,
            description: res.data.Description,
            secondDescription: res.data.SecDescription,
            entryTerm: res.data.EntryTerm,
            programOfStudyId: res.data.ProgramOfStudyId,
            selectedMajor: res.data.ProgramOfStudyId,
            selectedUniversity: res.data.UniversityId,
            selectedLanguage: res.data.Language,
            selectedSecondUniversity: res.data.SecondUniversityId,
            selectedSecondProgram: res.data.SecondProgramId,
            selectedSecondMajor: res.data.SecondMajorId,
            selectedSecondLanguage: res.data.SecondLanguage,
            selectedThirdUniversity: res.data.ThirdUniversityId,
            selectedThirdMajor: res.data.ThirdMajorId,
            selectedThirdLanguage: res.data.ThirdLanguage,
            selectedLevel: res.data.Level,
            selectedSecondLevel: res.data.SecondLevel,
            preferredCampus: res.data.PreferredCampus,
            /* Address */
            addressType: res.data.AddressTypeId,
            line1: res.data.Line1,
            line2: res.data.Line2,
            country: res.data.Country,
            city: res.data.City,
            region: res.data.Region,
            regionInput: res.data.RegionInput,
            //region: res.data.Region,
            dormPlanInterest: res.data.DormPlanInterest || false,
            address: {
              addressType: res.data.AddressTypeId,
              addressLine1: res.data.Line1,
              addressLine2: res.data.Line2,
              selectedCountry: res.data.Country,
              selectedCity: res.data.City,
              selectedRegion: res.data.Region,
              regionInput: res.data.RegionInput,
              dormPlanInterest: res.data.DormPlanInterest || false,
            },
            /* Parents Information */
            fatherInfo: res.data.FatherInfo,
            motherInfo: res.data.MotherInfo,
            /* Guardian Information */
            guardianInfo: res.data.GuardianInfo,
            /* Government Information */
            nationalIdNumber: res.data.NationalIdNumber,
            passportNumber: res.data.PassportNumber,
            passportCountry: res.data.PassportCountryIssued,
            passportExpiry: res.data.PassportExpirationDate,
            // governmentInformation: {
            //   passportNumber: res.data.PassportNumber,
            //   passportCountry: res.data.PassportCountryIssued,
            //   passportExpiryDate: res.data.PassportExpirationDate,
            //   nationalNumber: res.data.NationalIdNumber,
            // },
            /* Education*/
            educationHistory: res.data.EducationHistory,
            /* Test Section */
            testScoresProp: res.data.Tests,
            /* Health Information */
            hasBeenIll: res.data.HasBeenIll,
            illnessDescription: res.data.IllnessDescription,
            healthInformation: {
              illness: res.data.IllnessDescription || "",
              hasIllness: res.data.HasBeenIll || false,
            },
            /* Sources */
            sources: res.data.ApplicationTestSourceId,
            otherSource: res.data.OtherSource,
            sourceInfo: res.data.SourceInfo,
            sourceInformation: {
              ...this.state.sourceInformation,
              otherSource: res.data.OtherSource,
            },
            /* Policies */
            acceptedPolicy: res.data.AcceptedPolicies,
            /* Id */
            undergraduate: res.data.UndergraduateId /*  1 */,
            fatherId: res.data.FatherId,
            motherId: res.data.MotherId,
            graduate: res.data.GraduateId /* ? res.data.GraduateId : 3 */,
          });
          /*if (res.data.EducationHistory) {
            if (res.data.EducationHistory.length === 1) {
              const defaultVal = {
                CurriculumId: 0,
                EndDate: '0001-01-01T00:00:00',
                //EndDate:'',
                InstitutionName: null,
                CountryId: 0,
                GPA: 0.0,
                InstitutionId: 0,
                TranferedInstitutionName: null,
                TranferedInstitutionId: 0
              }
              if (JSON.stringify(defaultVal) === JSON.stringify(res.data.EducationHistory[0])) this.setState({ educationHistory: null })
            }
          }*/
        } else {
          this.setState({
            error: "Some Network Error Occured. Try again later. ",
          });
        }
      })
      .then(() =>
        fetch(`${process.env.REACT_APP_API_URL}/api/PersonalInfo/GetCountries`)
      )
      .then((res) => res.json())
      .then((res) => {
        if (res.length) {
          this.prepareState();
          this.setState({ countryData: res, loading: false });
        } else {
          this.setState({
            error: "Something wrong on our end. Please try again later.",
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: "Some Network Error Occured. Try again later",
        });
        console.log(err);
      });
    window.addEventListener("beforeunload", this.unloadEvent);
  }

  unloadEvent(e) {
    e.preventDefault();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.unloadEvent);
  }

  prepareState() {
    const {
      selectedUniversity,
      selectedSecondUniversity,
      selectedSecondProgram,
      selectedSecondMajor,
      selectedLevel,
      selectedSecondLevel,
      entryTerm,
      selectedProgram,
      programOfStudyId,
      description,
      secondDescription,
      guardianInfo,
      fatherInfo,
      motherInfo,
      sourceInfo,
      contactInformation,
      email,
      educationHistory,
      sources,
      undergraduate,
      fatherId,
      motherId,
      otherSource,
      testScoresProp,
      preferredCampus,
      letter,
      selectedLanguage,
      selectedSecondLanguage,
      selectedThirdMajor,
      selectedThirdUniversity,
      selectedThirdLanguage,
    } = this.state;
    // Program of Study
    const data = {
      selectedEntryTerm: entryTerm,
      selectedMajor: programOfStudyId,
      selectedUniversity: selectedUniversity,
      selectedLanguage: selectedLanguage,

      selectedSecondUniversity: selectedSecondUniversity,
      selectedSecondProgram: selectedSecondProgram,
      selectedSecondMajor: selectedSecondMajor,
      selectedSecondLanguage: selectedSecondLanguage,

      selectedThirdMajor: selectedThirdMajor,
      selectedThirdUniversity: selectedThirdUniversity,
      selectedThirdLanguage: selectedThirdLanguage,

      selectedProgram: selectedProgram,
      description: description,
      secondDescription: secondDescription,
      selectedLevel: selectedLevel,
      selectedSecondLevel: selectedSecondLevel,
      preferredCampus: preferredCampus,
    };

    // Guardian Information
    if (guardianInfo) {
      this.setState({
        guardianInformation: {
          guardianRelationship: guardianInfo.RelationType,
          guardianPrefix: guardianInfo.RelationPrefix,
          guardianFName: guardianInfo.RelationFirstName,
          guardianMName: guardianInfo.RelationMiddleName,
          guardianLName: guardianInfo.RelationLastName,
          guardianProfession: guardianInfo.Profession,
          guardianPhone: guardianInfo.MobileNumber,
          guardianEmail: guardianInfo.RelationEmail,
          guardianAddress: guardianInfo.GuardianAddress,
        },
      });
    }
    if (letter) {
      this.setState({
        letter: letter,
      });
    }
    this.setState({ ai: data });
    if (parseInt(data.selectedProgram) !== undergraduate) {
      this.setState({
        activeSections: [
          {
            name: "Personal Information",
            open: false,
          },
          {
            name: "Contact Details",
            open: false,
          },
          {
            name: "Family / Guardian Information",
            open: false,
          },
          {
            name: "Address",
            open: false,
          },
          {
            name: "Citizenship Information",
            open: false,
          },
          {
            name: "Program of Study",
            open: false,
          },
          {
            name: "Emergency Contact",
            open: false,
          },
          {
            name: "Education",
            open: false,
          },
          {
            name: "Test Scores",
            open: false,
          },
          {
            name: "Relationship with LGU",
            open: false,
          },
          {
            name: "Official Information In Arabic",
            open: false,
          },
          {
            name: "Motivation Letter",
            open: false,
          },
          {
            name: "Acknowledgement",
            open: false,
          },
        ],
      });
    } else {
      this.setState({
        activeSections: Array.from(this.state.sections),
      });
    }
    // Parents Information
    if (fatherInfo && motherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: fatherInfo.RelationPrefix,
          motherPrefix: motherInfo.RelationPrefix,
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: fatherInfo.RelationFirstName,
          motherFName: motherInfo.RelationFirstName,
          fatherMName: fatherInfo.RelationMiddleName,
          motherMName: motherInfo.RelationMiddleName,
          fatherLName: fatherInfo.RelationLastName,
          motherLName: motherInfo.RelationLastName,
          fatherProfession: fatherInfo.Profession,
          motherProfession: motherInfo.Profession,
          fatherCompany: fatherInfo.Company,
          motherCompany: motherInfo.Company,
          fatherCompanyAddress: fatherInfo.CompanyAddress,
          motherCompanyAddress: motherInfo.CompanyAddress,
          fatherPhone: fatherInfo.MobileNumber,
          motherPhone: motherInfo.MobileNumber,
          fatherEmail: fatherInfo.RelationEmail,
          motherEmail: motherInfo.RelationEmail,
          fatherAddress: fatherInfo.Address,
          motherAddress: motherInfo.Address,
          motherAttendedInstitution: motherInfo.AttendedInstitution,
          fatherAttendedInstitution: fatherInfo.AttendedInstitution,
          fatherDeceased: fatherInfo.Deceased,
          motherDeceased: motherInfo.Deceased,
          isFatherEmployee: fatherInfo.IsFatherTKHEmployee,
          fatherIdNumber: fatherInfo.FatherIdNumber,
          isMotherEmployee: motherInfo.IsMotherTKHEmployee,
          motherIdNumber: motherInfo.MotherIdNumber,
        },
      });
    } else if (fatherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: fatherInfo.RelationPrefix || "",
          motherPrefix: "",
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: fatherInfo.RelationFirstName || "",
          motherFName: "",
          fatherMName: fatherInfo.RelationMiddleName || "",
          motherMName: "",
          fatherLName: fatherInfo.RelationLastName || "",
          motherLName: "",
          fatherProfession: fatherInfo.Profession || "",
          motherProfession: "",
          fatherCompany: fatherInfo.Company || "",
          motherCompany: "",
          fatherCompanyAddress: fatherInfo.CompanyAddress || "",
          motherCompanyAddress: "",
          fatherPhone: fatherInfo.MobileNumber || "",
          motherPhone: "",
          fatherEmail: fatherInfo.RelationEmail || "",
          motherEmail: "",
          fatherAddress: fatherInfo.Address || "",
          motherAddress: "",
          motherAttendedInstitution: false,
          fatherAttendedInstitution: fatherInfo.AttendedInstitution || false,
          fatherDeceased: fatherInfo.Deceased,
          motherDeceased: "",
          isFatherEmployee: fatherInfo.IsFatherTKHEmployee || false,
          fatherIdNumber: fatherInfo.FatherIdNumber,
          isMotherEmployee: false,
          motherIdNumber: "",
        },
      });
    } else if (motherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: "",
          motherPrefix: motherInfo.RelationPrefix,
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: "",
          motherFName: motherInfo.RelationFirstName || "",
          fatherMName: "",
          motherMName: motherInfo.RelationMiddleName || "",
          fatherLName: "",
          motherLName: motherInfo.RelationLastName || "",
          fatherProfession: "",
          motherProfession: motherInfo.Profession || "",
          fatherCompany: "",
          motherCompany: motherInfo.Company || "",
          fatherCompanyAddress: "",
          motherCompanyAddress: motherInfo.CompanyAddress || "",
          fatherPhone: "",
          motherPhone: motherInfo.MobileNumber || "",
          fatherEmail: "",
          motherEmail: motherInfo.RelationEmail || "",
          fatherAddress: "",
          motherAddress: motherInfo.Address || "",
          motherAttendedInstitution: motherInfo.AttendedInstitution || false,
          fatherAttendedInstitution: false,
          fatherDeceased: "",
          motherDeceased: motherInfo.Deceased,
          isFatherEmployee: false,
          fatherIdNumber: "",
          isMotherEmployee: motherInfo.IsMotherTKHEmployee || false,
          motherIdNumber: motherInfo.MotherIdNumber,
        },
      });
    }
    // Contact Information
    if (contactInformation) {
      const newContactInfo = [];
      contactInformation.forEach((element, i) => {
        newContactInfo.push({
          phoneType: element.PhoneType,
          phoneCountry: element.CountryId,
          phoneNumber: element.PhoneNumber,
          isPrimary: element.IsPrimary,
          id: i,
        });
      });
      this.setState({
        contactInformations: {
          email: email,
          phoneNumberArray: newContactInfo,
        },
      });
    }
    // Test Scores
    if (testScoresProp && testScoresProp.length > 0) {
      const testScores = [];
      testScoresProp.forEach((element) => {
        testScores.push({
          test: element.Test,
          testType: element.TestType,
          score: element.Score,
          dateTaken: element.DateTaken,
        });
      });
      this.setState({
        testScores: { ...this.state.testScores, tests: testScores },
      });
    }

    // Education
    if (
      [undergraduate, "", null, undefined, 0].indexOf(
        parseInt(selectedProgram)
      ) === -1
    ) {
      // Graduate program
      if (
        false
        //educationHistory && educationHistory.length > 0
      ) {
        const graduateDegree = educationHistory.map((element) => ({
          universityCertificate: element.CurriculumId,
          yearOfGraduation: element.EndDate,
          selectedCountry: element.CountryId,
          selectedCity: element.CityId,
          gpa: element.GPA,
          universityName: element.InstitutionId,
          institutionName: element.InstitutionName,
          educationGrade: element.EducationGrade,
        }));

        this.setState({
          educationHistorys: {
            graduateDegree,
          },
        });
      }
    } // else if (parseInt(selectedProgram) === undergraduate) {
    else if (true) {
      // Undergraduate program
      if (educationHistory && educationHistory.length > 0) {
        const underGradDegree = educationHistory.map((element) => ({
          highSchoolCertificate: element.CurriculumId,
          endDate: element.EndDate,
          startDate: element.StartDate,
          selectedCountry: element.CountryId,
          selectedCity: element.CityId,
          highSchoolName: element.InstitutionId,
          sectionSpeciality: element.SectionSpeciality,
          institutionName: element.InstitutionName,
          perviousUniversityName: element.TranferedInstitutionName,
          perviousUniversity: element.TranferedInstitutionId,
          previousUniversityCertificate: element.TransferredCerti,
          previousUniversityGPA: element.TransferredGPA,
          educationGrade: element.EducationGrade,
          previousUniversityCountry: element.TransferCountryId,
          previousUniversityCity: element.TransferCityId,
          sectionSpeciality: element.SectionSpeciality,
        }));

        this.setState({
          educationHistorys: {
            underGradDegree,
          },
        });
      }
    } else {
      // Empty fallback
      this.setState({ educationHistorys: {} });
    }

    // Sources
    const newSources = [];
    if (sources) {
      sources.forEach((element) => {
        newSources.push(element.Id);
      });
      if (sourceInfo) {
        this.setState({
          sourceInformation: {
            guardianRelationship: sourceInfo.RelationType,
            guardianPrefix: sourceInfo.RelationPrefix,
            guardianFName: sourceInfo.RelationFirstName,
            guardianMName: sourceInfo.RelationMiddleName,
            guardianLName: sourceInfo.RelationLastName,
            guardianPhone: sourceInfo.MobileNumber,
            guardianEmail: sourceInfo.RelationEmail,
            guardianSuffix: sourceInfo.Suffix,
            selectedSources: newSources,
            otherSource: otherSource,
          },
        });
      } else {
        this.setState({
          sourceInformation: {
            guardianRelationship: "",
            guardianPrefix: "",
            guardianFName: "",
            guardianMName: "",
            guardianLName: "",
            guardianPhone: "",
            guardianEmail: "",
            guardianSuffix: "",
            selectedSources: newSources,
            otherSource: otherSource,
          },
        });
      }
    }
  }

  officialArabicInformationCheck(
    officialArabicInformation = this.state.officialArabicInformation
  ) {
    const errorOIA = {};
    const errorCheck = [0, "", null, undefined, NaN, "0"];

    const { arabicText1, arabicText2, arabicText3, arabicText4, arabicText5 } =
      officialArabicInformation;

    const selectedNationality =
      this.state.citizenshipInformation.selectedNationality;

    const allEmpty =
      errorCheck.includes(arabicText1) &&
      errorCheck.includes(arabicText2) &&
      errorCheck.includes(arabicText3) &&
      errorCheck.includes(arabicText4) &&
      errorCheck.includes(arabicText5);

    const anyFilled =
      !errorCheck.includes(arabicText1) ||
      !errorCheck.includes(arabicText2) ||
      !errorCheck.includes(arabicText3) ||
      !errorCheck.includes(arabicText4) ||
      !errorCheck.includes(arabicText5);

    if (selectedNationality == 50 || (!allEmpty && anyFilled)) {
      if (errorCheck.includes(arabicText1)) {
        errorOIA.arabicText1 = "Please Enter Arabic First Name";
      }
      if (errorCheck.includes(arabicText2)) {
        errorOIA.arabicText2 = "Please Enter Arabic Middle Name";
      }
      if (errorCheck.includes(arabicText3)) {
        errorOIA.arabicText3 = "Please Enter Arabic Last Name";
      }
      if (errorCheck.includes(arabicText4)) {
        errorOIA.arabicText4 = "Please Enter Your Civil Id";
      }
      if (errorCheck.includes(arabicText5)) {
        errorOIA.arabicText5 = "Please Enter Arabic City";
      }

      const hasErrors = Object.keys(errorOIA).length > 0;
      this.setState({ errorOIA });
      return hasErrors ? 0 : 1;
    }

    // Case 2: Nationality ≠ 50 and all empty → skip validation
    this.setState({ errorOIA: {} });
    return 1;
  }

  personalInformationCheck(
    personalInformation = this.state.personalInformation
  ) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorPI = {};
    let isValid = true;

    // Mandatory fields
    if (!personalInformation.fName) {
      errorPI.fName = "Please Enter First Name";
      isValid = false;
    }
    if (!personalInformation.lName) {
      errorPI.lName = "Please Enter Last Name";
      isValid = false;
    }
    if (!personalInformation.selectedGender) {
      errorPI.selectedGender = "Please Enter Gender";
      isValid = false;
    }

    if (!(errorCheck.indexOf(personalInformation.dateOfBirth) === -1)) {
      errorPI.dateOfBirth = "Please Select A Date Of Birth";
      isValid = false;
    }

    this.setState({ errorPI });
    return isValid ? 1 : 0;
  }

  academicInterestCheck(ai = this.state.ai) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorAI = {};
    let isValid = true;

    if (errorCheck.includes(ai.selectedEntryTerm)) {
      errorAI.selectedEntryTerm = "Please select the entry term";
      isValid = false;
    }

    // First choice - always required
    if (errorCheck.includes(ai.selectedUniversity)) {
      errorAI.selectedUniversity = "Please Select University";
      isValid = false;
    }
    if (errorCheck.includes(ai.selectedMajor)) {
      errorAI.selectedMajor = "Please Select Major";
      isValid = false;
    }
    if (errorCheck.includes(ai.selectedLanguage)) {
      errorAI.selectedLanguage = "Please Select Language";
      isValid = false;
    }

    // Second choice - only validate if any of the 3 is filled
    const hasSecond =
      !errorCheck.includes(ai.selectedSecondUniversity) ||
      !errorCheck.includes(ai.selectedSecondMajor) ||
      !errorCheck.includes(ai.selectedSecondLanguage);

    if (hasSecond) {
      if (errorCheck.includes(ai.selectedSecondUniversity)) {
        errorAI.selectedSecondUniversity = "Please Select Second University";
        isValid = false;
      }
      if (errorCheck.includes(ai.selectedSecondMajor)) {
        errorAI.selectedSecondMajor = "Please Select Second Major";
        isValid = false;
      }
      if (errorCheck.includes(ai.selectedSecondLanguage)) {
        errorAI.selectedSecondLanguage = "Please Select Second Language";
        isValid = false;
      }
    }

    // Third choice - only validate if any of the 3 is filled
    const hasThird =
      !errorCheck.includes(ai.selectedThirdUniversity) ||
      !errorCheck.includes(ai.selectedThirdMajor) ||
      !errorCheck.includes(ai.selectedThirdLanguage);

    if (hasThird) {
      if (errorCheck.includes(ai.selectedThirdUniversity)) {
        errorAI.selectedThirdUniversity = "Please Select Third University";
        isValid = false;
      }
      if (errorCheck.includes(ai.selectedThirdMajor)) {
        errorAI.selectedThirdMajor = "Please Select Third Major";
        isValid = false;
      }
      if (errorCheck.includes(ai.selectedThirdLanguage)) {
        errorAI.selectedThirdLanguage = "Please Select Third Language";
        isValid = false;
      }
    }

    this.setState({ errorAI });
    return isValid ? 1 : 0;
  }

  citizenshipCheck(citizenshipInformation = this.state.citizenshipInformation) {
    // Citizenship Information
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorCIT = {};
    if (
      errorCheck.indexOf(citizenshipInformation.selectedCountry) &&
      errorCheck.indexOf(citizenshipInformation.selectedNationality)
    ) {
      this.setState({ errorCI: {} });
      return 1;
    } else {
      const errorCIT = {};
      if (!errorCheck.indexOf(citizenshipInformation.selectedCountry)) {
        errorCIT.passportNumber = "Please Enter Your Country of Birth";
      }
      if (!errorCheck.indexOf(citizenshipInformation.selectedNationality)) {
        errorCIT.passportExpiryDate = "Please Enter Your Nationality";
      }
      this.setState({ errorCIT: errorCIT });
      return 0;
    }
  }

  addressCheck(address = this.state.address) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    if (
      errorCheck.indexOf(address.addressType) === -1 &&
      (address.selectedCity || Number(address.selectedCountry) !== 1) &&
      errorCheck.indexOf(address.selectedCountry) === -1 &&
      (errorCheck.indexOf(address.selectedRegion) === -1 ||
        errorCheck.indexOf(address.regionInput) === -1)
    ) {
      this.setState({ errorAdd: {} });
      return 1;
    } else {
      const errorAdd = {};
      if (errorCheck.indexOf(address.addressType) !== -1) {
        errorAdd.addressType = "Please Select Address Type";
      }
      if (!address.addressLine1) {
        errorAdd.addressLine1 = "Please Enter Building";
      }
      if (!address.addressLine2) {
        errorAdd.addressLine2 = "Please Enter Street";
      }
      if (errorCheck.indexOf(address.selectedCountry) !== -1) {
        errorAdd.selectedCountry = "Please Select Country";
      }
      if (
        errorCheck.indexOf(address.selectedRegion) !== -1 &&
        errorCheck.indexOf(address.regionInput) !== -1
      ) {
        errorAdd.selectedRegion = "Please Enter City";
        errorAdd.regionInput = "Please Enter City";
      }
      if (
        errorCheck.indexOf(address.selectedCity) !== -1 &&
        Number(address.selectedCountry) === 1
      ) {
        errorAdd.selectedCity = "Please Enter District";
      }
      this.setState({ errorAdd });
      return 0;
    }
  }

  contactCheck(contactInformations = this.state.contactInformations) {
    // Contact Information
    // const {
    //   contactInformations
    // } = this.state
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    let countC = 0;
    const errorContact = {};
    if (
      contactInformations.phoneNumberArray &&
      contactInformations.phoneNumberArray.length >= 1
    ) {
      contactInformations.phoneNumberArray.forEach((element, index) => {
        errorContact[index] = {};
        if (
          errorCheck.indexOf(element.phoneNumber) !== -1 ||
          errorCheck.indexOf(element.phoneType) !== -1 ||
          errorCheck.indexOf(element.phoneCountry) !== -1
        ) {
          if (errorCheck.indexOf(element.phoneNumber) !== -1) {
            errorContact[index].phoneNumber = "Please Enter Number";
          }
          if (errorCheck.indexOf(element.phoneType) !== -1) {
            errorContact[index].phoneType = "Please Select Phone Type";
          }
          if (errorCheck.indexOf(element.phoneCountry) !== -1) {
            errorContact[index].phoneCountry = "Please Select Country";
          }
          countC = 1;
        }
      });
      if (countC === 0 && emailCheck.test(contactInformations.email)) {
        this.setState({ errorContact: {} });
        return 1;
      } else {
        this.setState({ errorContact: errorContact });
        return 0;
      }
    } else {
      errorContact[0] = {};
      errorContact[0].phoneNumber = "Please Enter Number";
      errorContact[0].phoneType = "Please Select Phone Type";
      errorContact[0].phoneCountry = "Please Select Country";
      this.setState({ errorContact: errorContact });
      return 0;
    }
  }

  parentsInformationCheck(parentsInformation = this.state.parentsInformation) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorParent = {};
    let isValid = true;

    if (errorCheck.includes(parentsInformation.fatherRelationship)) {
      errorParent.fatherRelationship = "Please Select Relationship";
      isValid = false;
    }

    if (errorCheck.includes(parentsInformation.motherRelationship)) {
      errorParent.motherRelationship = "Please Select Relationship";
      isValid = false;
    }

    // Father validations (if alive)
    if (!parentsInformation.fatherDeceased) {
      if (!parentsInformation.fatherFName) {
        errorParent.fatherFName = "Please Enter First Name";
        isValid = false;
      }
      if (!parentsInformation.fatherPhone) {
        errorParent.fatherPhone = "Please Enter Number";
        isValid = false;
      }
    }

    // Mother validations (if alive)
    if (!parentsInformation.motherDeceased) {
      if (!parentsInformation.motherFName) {
        errorParent.motherFName = "Please Enter First Name";
        isValid = false;
      }
      if (!parentsInformation.motherPhone) {
        errorParent.motherPhone = "Please Enter Number";
        isValid = false;
      }
    }

    this.setState({ errorParent });
    return isValid ? 1 : 0;
  }

  guardianInformationCheck = (
    guardianInformation = this.state.guardianInformation
  ) => {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorGuard = {};
    let isValid = true;

    /* ---------- required-field validation ---------- */
    if (!guardianInformation.guardianFName) {
      errorGuard.guardianFName = "Please Enter First Name";
      isValid = false;
    }

    if (!guardianInformation.guardianLName) {
      errorGuard.guardianLName = "Please Enter Last Name";
      isValid = false;
    }

    if (!guardianInformation.guardianPhone) {
      errorGuard.guardianPhone = "Please Enter Number";
      isValid = false;
    }

    if (
      guardianInformation.guardianEmail && // validate only if provided
      !emailCheck.test(guardianInformation.guardianEmail)
    ) {
      errorGuard.guardianEmail = "Please Enter a Valid Email Address";
      isValid = false;
    }

    /* ---------- relationship must be selected ---------- */
    if (errorCheck.includes(guardianInformation.guardianRelationship)) {
      errorGuard.guardianRelationship = "Please Select Relationship";
      isValid = false;
    }

    /* ---------- push errors & return result ---------- */
    this.setState({ errorGuard });
    return isValid ? 1 : 0; // keep existing caller-contract
  };

  educationHistoryCheck(educationHistorys = this.state.educationHistorys) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const entries = educationHistorys.underGradDegree || [];

    const errorEdu = [];
    if (!Array.isArray(entries) || entries.length === 0) {
      this.setState({
        errorEdu: [{ sectionError: "Education section is required" }],
      });
      return 0;
    }

    const lastIndex = entries.length - 1;
    const entry = entries[lastIndex];
    const entryError = {};

    if (errorCheck.includes(entry.startDate)) {
      entryError.startDate = "Please Select Start Date";
    }
    if (errorCheck.includes(entry.endDate)) {
      entryError.endDate = "Please Select End Date";
    }
    if (errorCheck.includes(entry.highSchoolCertificate)) {
      entryError.highSchoolCertificate =
        "Please Select High School Certificate";
    }
    if (errorCheck.includes(entry.highSchoolName)) {
      entryError.highSchoolName = "Please Select High School Name";
    }
    if (
      entry.highSchoolName === "8" &&
      errorCheck.includes(entry.institutionName)
    ) {
      entryError.institutionName = "Please Enter Institution Name";
    }

    // Build error array to match entries
    for (let i = 0; i < entries.length; i++) {
      errorEdu.push(i === lastIndex ? entryError : {});
    }

    this.setState({ errorEdu });

    return Object.keys(entryError).length === 0 ? 1 : 0;
  }

  testScoresCheck(testScores = this.state.testScores) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    if (testScores.tests && testScores.tests.length > 0) {
      const testArray = testScores.tests;
      let count = 1;
      const errorTest = [];
      testArray.forEach((element, index) => {
        errorTest[index] = {};
        if (
          errorCheck.indexOf(element.test) !== -1 &&
          errorCheck.indexOf(element.testType) !== -1 &&
          errorCheck.indexOf(element.dateTaken) !== -1 &&
          errorCheck.indexOf(element.score) !== -1
        ) {
          errorTest[index] = {};
        } else if (
          errorCheck.indexOf(element.test) !== -1 ||
          errorCheck.indexOf(element.testType) !== -1 ||
          errorCheck.indexOf(element.dateTaken) !== -1 ||
          errorCheck.indexOf(element.score) !== -1
        ) {
          count = 0;
          if (errorCheck.indexOf(element.test) !== -1) {
            errorTest[index].test = "Please select test";
          }
          if (errorCheck.indexOf(element.testType) !== -1) {
            errorTest[index].testType = "Please select test type";
          }
          if (errorCheck.indexOf(element.score) !== -1) {
            errorTest[index].score = "Please enter score";
          }
          if (errorCheck.indexOf(element.dateTaken) !== -1) {
            errorTest[index].dateTaken = "Please enter date taken";
          }
        }
      });

      if (count === 1) {
        this.setState({ errorTest: [] });
        return 1;
      } else {
        this.setState({ errorTest: errorTest });
        return 0;
      }
    } /* else {
      const errorTest = [{}]
      errorTest[0].test = 'Please select test'
      errorTest[0].testType = 'Please select test type'
      errorTest[0].score = 'Please enter score'
      errorTest[0].dateTaken = 'Please enter date taken'
      this.setState({ errorTest: errorTest })
      return 0
    } */
  }

  // healthInformationCheck(healthInformation = this.state.healthInformation) {
  //   // Health Information
  //   // const {
  //   //   healthInformation
  //   // } = this.state
  //   if (
  //     (healthInformation.hasIllness ||
  //       healthInformation.hasIllness === "True") &&
  //     healthInformation.illness
  //   ) {
  //     this.setState({ errorHI: {} });
  //     return 1;
  //   } else if (
  //     !healthInformation.hasIllness ||
  //     healthInformation.hasIllness === "False"
  //   ) {
  //     this.setState({ errorHI: {} });
  //     return 1;
  //   } else {
  //     this.setState({
  //       errorHI: { illness: "Please fill required information" },
  //     });
  //     return 0;
  //   }
  // }

  sourcesCheck(sourceInformation = this.state.sourceInformation) {
    // Sources check
    if (
      sourceInformation.selectedSources &&
      sourceInformation.selectedSources.length >= 1
    ) {
      if (
        sourceInformation.selectedSources.includes(16) &&
        !sourceInformation.otherSource
      ) {
        this.setState({
          errorSources: { general: "Please Specify the other value." },
        });
        return 0;
      }
    } else {
      this.setState({
        errorSources: { general: "Please Select at-least one." },
      });
      return 0;
    }

    // Guardian check
    const {
      guardianRelationship,
      guardianPrefix,
      guardianFName,
      guardianLName,
      guardianPhone,
      guardianEmail,
      guardianSuffix,
    } = sourceInformation;

    const anyFilled =
      guardianRelationship ||
      guardianPrefix ||
      guardianFName ||
      guardianLName ||
      guardianPhone ||
      guardianEmail ||
      guardianSuffix;

    if (anyFilled) {
      const errors = {};

      if (!guardianRelationship) errors.guardianRelationship = "Required";
      if (!guardianFName) errors.guardianFName = "Required";
      if (!guardianLName) errors.guardianLName = "Required";
      if (!guardianPhone) errors.guardianPhone = "Required";
      if (!guardianEmail) errors.guardianEmail = "Required";
      if (!guardianSuffix) errors.guardianSuffix = "Required";

      if (Object.keys(errors).length > 0) {
        this.setState({ errorSources: errors });
        return 0;
      }
    }

    this.setState({ errorSources: {} });
    return 1;
  }

  conditionCheck() {
    const count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    // Personal Information
    count[0] = this.personalInformationCheck();
    // Contact Information
    count[1] = this.contactCheck();
    // Parents Information
    count[2] = this.parentsInformationCheck();
    // Address
    count[3] = this.addressCheck();
    // Citizenship Information
    count[4] = this.citizenshipCheck();
    // Program of Study
    count[5] = this.academicInterestCheck();
    // Guardian Information
    count[6] = this.guardianInformationCheck();
    // Education
    count[7] = this.educationHistoryCheck();
    // Test Scores
    count[8] = this.testScoresCheck();
    // Sources
    count[9] = this.sourcesCheck();
    // Official Arabic Information
    count[10] = this.officialArabicInformationCheck();
    // Motivation Letter
    count[11] = 1;

    this.setState({ count: count });
    return count;
  }

  getActiveTabBody(i) {
    const {
      //healthInformation,
      sourceInformation,
      acceptedPolicies,
      countryData,
      dateOfBirth,
      countryOfBirth,
      nationality,
      cityOfBirth,
      otherNationality,

      gender,
      fName,
      lName,
      mName,

      arabicData,
      incompleteApplicationId,
      siblingFName,
      siblingMName,
      siblingLName,
      siblingTKHNumber,
      selectedUniversity,
      selectedProgram,
      selectedLevel,
      selectedLanguage,
      selectedMajor,

      selectedSecondUniversity,
      selectedSecondMajor,
      selectedSecondLevel,
      selectedSecondProgram,
      selectedSecondLanguage,

      selectedThirdUniversity,
      selectedThirdMajor,
      selectedThirdProgram,
      selectedThirdLanguage,

      entryTerm,
      description,
      secondDescription,
      nationalIdNumber,
      passportNumber,
      passportCountry,
      passportExpiry,

      addressType,
      line1,
      line2,
      country,
      city,
      region,
      regionInput,

      contactInformation,
      email,

      fatherInfo,
      motherInfo,

      guardianInfo,
      educationHistory,
      hasBeenIll,
      illnessDescription,
      errorPI,
      errorAI,
      errorGI,
      errorAdd,
      errorCIT,
      errorOIA,
      errorContact,
      errorParent,
      errorGuard,
      errorEdu,
      errorHI,
      errorSources,
      ai,
      personalInformation,
      citizenshipInformation,
      parentsInformation,
      undergraduate,
      fatherId,
      motherId,
      otherSource,
      testScores,
      errorTest,
      isFoundation,
      preferredCampus,
      dormPlanInterest,
      letter,
    } = this.state;
    let returnValue = "";
    const selectedSources = [];
    if (
      sourceInformation.selectedSources &&
      sourceInformation.selectedSources.length > 0
    ) {
      sourceInformation.selectedSources.forEach((element) => {
        selectedSources.push({
          Id: element,
        });
      });
    }

    if (
      ai.selectedProgram &&
      (parseInt(ai.selectedProgram) === undergraduate ||
        ai.selectedProgram === "")
    ) {
      switch (i) {
        case 0:
          returnValue = (
            <PersonalInformation
              gender={gender || ""}
              arabicData={arabicData || []}
              incompleteApplicationId={incompleteApplicationId}
              error={errorPI}
              onSave={() => this.toggleAccordion(1)}
              fName={fName}
              lName={lName}
              mName={mName}
              collectState={this.collectState}
              dateOfBirth={dateOfBirth || ""}
              // countryData={countryData || 0}
              // nationality={nationality || 0}
              // countryOfBirth={countryOfBirth || 0}
              // siblingFName={siblingFName || ""}
              // siblingMName={siblingMName || ""}
              // siblingLName={siblingLName || ""}
              // siblingTKHNumber={siblingTKHNumber || ""}
            />
          );
          break;
        case 1:
          returnValue = (
            <Contact
              contactInformation={contactInformation || []}
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              onSave={() => this.toggleAccordion(2)}
              collectState={this.collectState}
              error={errorContact}
              email={email}
              getDefaultValue={this.getDefaultValue}
            />
          );
          break;
        case 2:
          returnValue = (
            <ParentsInformation
              fatherInfo={fatherInfo || {}}
              motherInfo={motherInfo || {}}
              fatherId={fatherId}
              motherId={motherId}
              incompleteApplicationId={incompleteApplicationId}
              onSave={(motherInfo, fatherInfo) => {
                this.setState({
                  motherInfo: motherInfo,
                  fatherInfo: fatherInfo,
                });
                this.toggleAccordion(3);
              }}
              error={errorParent}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
            />
          );
          break;
        case 3:
          returnValue = (
            <Address
              addressType={addressType}
              line1={line1}
              line2={line2}
              country={country}
              city={city}
              region={region}
              regionInput={regionInput}
              dormPlanInterest={dormPlanInterest || false}
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              onSave={() => this.toggleAccordion(4)}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
              error={errorAdd}
            />
          );
          break;
        case 4:
          returnValue = (
            <Citizenship
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData || 0}
              countryOfBirth={countryOfBirth || 0}
              nationality={nationality || 0}
              cityOfBirth={cityOfBirth || ""}
              otherNationality={otherNationality || 0}
              onSave={() => this.toggleAccordion(5)}
              collectState={this.collectState}
              error={errorCIT}
              email={email}
            />
          );
          break;
        case 5:
          returnValue = (
            <AcademicInterest
              incompleteApplicationId={incompleteApplicationId}
              entryTerm={entryTerm || ""}
              description={description || ""}
              selectedLevel={selectedLevel || ""}
              selectedMajor={selectedMajor || ""}
              selectedSecondLevel={selectedSecondLevel || ""}
              secondDescription={secondDescription || ""}
              selectedUniversity={selectedUniversity || ""}
              selectedProgram={selectedProgram || ""}
              selectedLanguage={selectedLanguage || ""}
              selectedSecondUniversity={selectedSecondUniversity || ""}
              selectedSecondMajor={selectedSecondMajor || ""}
              selectedSecondProgram={selectedSecondProgram || ""}
              selectedSecondLanguage={selectedSecondLanguage || ""}
              selectedThirdUniversity={selectedThirdUniversity || ""}
              selectedThirdMajor={selectedThirdMajor || ""}
              selectedThirdProgram={selectedThirdProgram || ""}
              selectedThirdLanguage={selectedThirdLanguage || ""}
              onSave={async (program) => {
                this.toggleAccordion(6);
              }}
              collectState={this.collectState}
              error={errorAI}
              isFoundation={isFoundation}
              preferredCampus={preferredCampus || ""}
              changePopup={this.changePopup}
            />
          );
          break;
        case 6:
          const fatherInfos = {
            RelationFirstName: parentsInformation.fatherFName,
            RelationMiddleName: parentsInformation.fatherMName,
            RelationLastName: parentsInformation.fatherLName,
            RelationPrefix: parentsInformation.fatherPrefix,
            RelationType: fatherId,
            Profession: parentsInformation.fatherProfession,
            Company: parentsInformation.fatherCompany,
            CompanyAddress: parentsInformation.fatherCompanyAddress,
            MobileNumber: parentsInformation.fatherPhone,
            RelationEmail: parentsInformation.fatherEmail,
            Address: parentsInformation.fatherAddress,
          };
          const motherInfos = {
            RelationFirstName: parentsInformation.motherFName,
            RelationMiddleName: parentsInformation.motherMName,
            RelationLastName: parentsInformation.motherLName,
            RelationPrefix: parentsInformation.motherPrefix,
            RelationType: motherId,
            Profession: parentsInformation.motherProfession,
            Company: parentsInformation.motherCompany,
            CompanyAddress: parentsInformation.motherCompanyAddress,
            MobileNumber: parentsInformation.motherPhone,
            RelationEmail: parentsInformation.motherEmail,
            Address: parentsInformation.motherAddress,
          };
          returnValue = (
            <GuardianInformation
              incompleteApplicationId={incompleteApplicationId}
              motherInfo={motherInfos || motherInfo || {}}
              fatherInfo={fatherInfos || fatherInfo || {}}
              lName={lName}
              guardianInfo={guardianInfo || {}}
              motherId={motherId}
              fatherId={fatherId}
              onSave={() => this.toggleAccordion(7)}
              error={errorGuard}
              collectState={this.collectState}
            />
          );
          break;
        case 7:
          const userSelectedProgram =
            parseInt(ai.selectedProgram) || parseInt(selectedProgram);
          // if (
          //   [undergraduate, "", null, undefined, 0].indexOf(
          //     parseInt(userSelectedProgram)
          //   ) === -1 &&
          //   !isNaN(userSelectedProgram)
          // ) {
          //   returnValue = (
          //     <EducationHistoryGraduate
          //       incompleteApplicationId={incompleteApplicationId}
          //       onSave={() => this.toggleAccordion(8)}
          //       countryData={countryData}
          //       educationHistory={educationHistory || []}
          //       program={parseInt(selectedProgram)}
          //       collectState={this.collectState}
          //       error={errorEdu}
          //     />
          //   );
          // }
          //else {
          returnValue = (
            <EducationHistoryUndergraduate
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              educationHistory={educationHistory || []}
              program={parseInt(selectedProgram)}
              collectState={this.collectState}
              error={errorEdu}
              changeFoundation={this.changeFoundation}
              onSave={() => this.toggleAccordion(8)}
            />
          );

          break;
        case 8:
          returnValue = (
            <TestScores
              collectState={this.collectState}
              testScore={testScores}
              error={errorTest}
              onSave={() => this.toggleAccordion(9)}
            />
          );
          break;
        case 9:
          returnValue = (
            <Sources
              incompleteApplicationId={incompleteApplicationId}
              sources={selectedSources || []}
              sourceInfo={sourceInformation || {}}
              otherSource={otherSource || null}
              collectState={this.collectState}
              error={errorSources}
              onSave={() => this.toggleAccordion(10)}
            />
          );
          break;
        case 10:
          returnValue = (
            <ArabicInformation
              incompleteApplicationId={incompleteApplicationId}
              arabicData={arabicData || []}
              onSave={() => this.toggleAccordion(11)}
              collectState={this.collectState}
              error={errorOIA}
              email={email}
            />
          );
          break;

        case 11:
          returnValue = (
            <MotivationLetter
              incompleteApplicationId={incompleteApplicationId}
              collectState={this.collectState}
              letter={letter || ""}
              onSave={() => this.toggleAccordion(12)}
            />
          );
          break;
        case 12:
          returnValue = (
            <Policies
              incompleteApplicationId={incompleteApplicationId}
              acceptedPolicies={acceptedPolicies}
              collectState={this.collectState}
              preferredCampus={preferredCampus || ""}
            />
          );
          break;
        default:
          returnValue = <p>Work in Progress</p>;
          break;
      }
    } else {
      switch (i) {
        case 0:
          returnValue = (
            <PersonalInformation
              gender={gender || ""}
              incompleteApplicationId={incompleteApplicationId}
              error={errorPI}
              onSave={() => this.toggleAccordion(1)}
              fName={fName}
              lName={lName}
              mName={mName}
              collectState={this.collectState}
              dateOfBirth={dateOfBirth || ""}
              //arabicData={arabicData || []}
              // countryData={countryData || 0}
              // nationality={nationality || 0}
              // countryOfBirth={countryOfBirth || 0}
              // siblingFName={siblingFName || ""}
              // siblingMName={siblingMName || ""}
              // siblingLName={siblingLName || ""}
              // siblingTKHNumber={siblingTKHNumber || ""}
            />
          );
          break;
        case 1:
          returnValue = (
            <Contact
              contactInformation={contactInformation || []}
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              onSave={() => this.toggleAccordion(2)}
              collectState={this.collectState}
              error={errorContact}
              email={email}
              getDefaultValue={this.getDefaultValue}
            />
          );
          break;
        case 2:
          returnValue = (
            <ParentsInformation
              fatherInfo={fatherInfo || {}}
              motherInfo={motherInfo || {}}
              fatherId={fatherId}
              motherId={motherId}
              incompleteApplicationId={incompleteApplicationId}
              onSave={(motherInfo, fatherInfo) => {
                this.setState({
                  motherInfo: motherInfo,
                  fatherInfo: fatherInfo,
                });
                this.toggleAccordion(3);
              }}
              error={errorParent}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
            />
          );
          break;
        case 3:
          returnValue = (
            <Address
              addressType={addressType}
              line1={line1}
              line2={line2}
              country={country}
              city={city}
              region={region}
              regionInput={regionInput}
              dormPlanInterest={dormPlanInterest || false}
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              onSave={() => this.toggleAccordion(4)}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
              error={errorAdd}
            />
          );
          break;
        case 4:
          returnValue = (
            <Citizenship
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData || 0}
              countryOfBirth={countryOfBirth || 0}
              nationality={nationality || 0}
              cityOfBirth={cityOfBirth || 0}
              otherNationality={otherNationality || 0}
              onSave={() => this.toggleAccordion(5)}
              collectState={this.collectState}
              error={errorCIT}
              email={email}
            />
          );
          break;
        case 5:
          returnValue = (
            <AcademicInterest
              selectedUniversity={selectedUniversity || ""}
              selectedSecondUniversity={selectedSecondUniversity || ""}
              selectedSecondMajor={selectedSecondMajor || ""}
              selectedMajor={selectedMajor || ""}
              selectedLevel={selectedLevel || ""}
              selectedLanguage={selectedLanguage || ""}
              selectedSecondLevel={selectedSecondLevel || ""}
              selectedSecondProgram={selectedSecondProgram || ""}
              selectedSecondLanguage={selectedSecondLanguage || ""}
              selectedProgram={selectedProgram || ""}
              selectedThirdUniversity={selectedThirdUniversity || ""}
              selectedThirdMajor={selectedThirdMajor || ""}
              selectedThirdProgram={selectedThirdProgram || ""}
              selectedThirdLanguage={selectedThirdLanguage || ""}
              incompleteApplicationId={incompleteApplicationId}
              entryTerm={entryTerm || ""}
              description={description || ""}
              secondDescription={secondDescription || ""}
              onSave={async (program) => {
                this.toggleAccordion(6);
              }}
              collectState={this.collectState}
              error={errorAI}
              isFoundation={isFoundation}
              preferredCampus={preferredCampus || ""}
              changePopup={this.changePopup}
            />
          );
          break;
        case 6:
          const fatherInfos = {
            RelationFirstName: parentsInformation.fatherFName,
            RelationMiddleName: parentsInformation.fatherMName,
            RelationLastName: parentsInformation.fatherLName,
            RelationPrefix: parentsInformation.fatherPrefix,
            RelationType: fatherId,
            Profession: parentsInformation.fatherProfession,
            Company: parentsInformation.fatherCompany,
            CompanyAddress: parentsInformation.fatherCompanyAddress,
            MobileNumber: parentsInformation.fatherPhone,
            RelationEmail: parentsInformation.fatherEmail,
            Address: parentsInformation.fatherAddress,
          };
          const motherInfos = {
            RelationFirstName: parentsInformation.motherFName,
            RelationMiddleName: parentsInformation.motherMName,
            RelationLastName: parentsInformation.motherLName,
            RelationPrefix: parentsInformation.motherPrefix,
            RelationType: motherId,
            Profession: parentsInformation.motherProfession,
            Company: parentsInformation.motherCompany,
            CompanyAddress: parentsInformation.motherCompanyAddress,
            MobileNumber: parentsInformation.motherPhone,
            RelationEmail: parentsInformation.motherEmail,
            Address: parentsInformation.motherAddress,
          };
          returnValue = (
            <GuardianInformation
              incompleteApplicationId={incompleteApplicationId}
              motherInfo={motherInfos || motherInfo || {}}
              fatherInfo={fatherInfos || fatherInfo || {}}
              guardianInfo={guardianInfo || {}}
              motherId={motherId}
              fatherId={fatherId}
              lName={lName}
              onSave={() => this.toggleAccordion(7)}
              error={errorGuard}
              collectState={this.collectState}
            />
          );
          break;
        case 7:
          const userSelectedProgram =
            parseInt(ai.selectedProgram) || parseInt(selectedProgram);
          if (
            [undergraduate, "", null, undefined, 0].indexOf(
              parseInt(userSelectedProgram)
            ) === -1 &&
            !isNaN(userSelectedProgram)
          ) {
            returnValue = (
              <EducationHistoryGraduate
                incompleteApplicationId={incompleteApplicationId}
                onSave={() => this.toggleAccordion(8)}
                countryData={countryData}
                educationHistory={educationHistory || []}
                program={parseInt(selectedProgram)}
                collectState={this.collectState}
                error={errorEdu}
              />
            );
          } else {
            returnValue = (
              <EducationHistoryUndergraduate
                incompleteApplicationId={incompleteApplicationId}
                countryData={countryData}
                educationHistory={educationHistory || []}
                program={parseInt(selectedProgram)}
                collectState={this.collectState}
                error={errorEdu}
                changeFoundation={this.changeFoundation}
                onSave={() => this.toggleAccordion(8)}
              />
            );
          }
          break;
        case 8:
          returnValue = (
            <TestScores
              collectState={this.collectState}
              testScore={testScores}
              error={errorTest}
              onSave={() => this.toggleAccordion(9)}
            />
          );
          break;
        case 9:
          returnValue = (
            <Sources
              incompleteApplicationId={incompleteApplicationId}
              sources={selectedSources || []}
              sourceInfo={sourceInformation || {}}
              otherSource={otherSource || null}
              collectState={this.collectState}
              error={errorSources}
              onSave={() => this.toggleAccordion(10)}
            />
          );
          break;
        case 10:
          returnValue = (
            <ArabicInformation
              incompleteApplicationId={incompleteApplicationId}
              arabicData={arabicData || []}
              onSave={() => this.toggleAccordion(11)}
              collectState={this.collectState}
              error={errorOIA}
              email={email}
            />
          );
          break;
        case 11:
          returnValue = (
            <MotivationLetter
              incompleteApplicationId={incompleteApplicationId}
              collectState={this.collectState}
              letter={letter || ""}
              onSave={() => this.toggleAccordion(12)}
            />
          );
          break;
        case 12:
          returnValue = (
            <Policies
              incompleteApplicationId={incompleteApplicationId}
              acceptedPolicies={acceptedPolicies}
              collectState={this.collectState}
              preferredCampus={preferredCampus || ""}
            />
          );
          break;
        default:
          returnValue = <p>Work in Progress</p>;
          break;
      }
    }
    return <div className="accordionSectionBody">{returnValue}</div>;
  }
  changeFoundation(value) {
    this.setState({ isFoundation: value });
  }
  changePopup(value) {
    if (value == true)
      this.setState({ isPopup: value, preferredCampus: "West" });
    else if (value == false)
      this.setState({ isPopup: value, preferredCampus: "East" });
    else if (value == "WestRemoved")
      this.setState({
        preferredCampus: "",
        selectedMajor: 0,
        selectedLevel: 0,
      });
  }

  collectState(componentName, data) {
    switch (componentName) {
      case "PI":
        this.setState({
          personalInformation: data,
          lName: data.lName, // ← ① keep a top-level copy
        });
        const { errorPI } = this.state;
        const errorPIKeys = Object.keys(errorPI);
        if (errorPIKeys.length) {
          const returnValue = this.personalInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[0] = 1;
            this.setState({ count: count });
          }
        }
        break;

      case "CIT":
        this.setState({ citizenshipInformation: data });
        const { errorCIT } = this.state;
        const errorCITKeys = Object.keys(errorCIT);
        if (errorCITKeys.length) {
          const returnValue = this.citizenshipCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[4] = 1;
            this.setState({ count: count });
          }
        }
        break;

      case "OIA":
        this.setState({ officialArabicInformation: data });
        const { errorOIA } = this.state;
        const errorOIAKeys = Object.keys(errorOIA);
        if (errorOIAKeys.length) {
          const returnValue = this.officialArabicInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[10] = 1;
            this.setState({ count: count });
          }
        }
        break;

      case "MotivationLetter":
        this.setState({ letter: data });
        break;

      case "EH":
        this.setState({ educationHistorys: data });
        const { errorEdu } = this.state;
        const errorEduKeys = Object.keys(errorEdu);
        if (errorEduKeys.length) {
          const returnValue = this.educationHistoryCheck(data);

          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[7] = 1;
            this.setState({ count: count });
          }
        }
        break;

      case "AI":
        const accordionValue = this.state.activeSections[5].open;
        if (data.selectedProgram + "" !== this.state.ai.selectedProgram + "") {
          this.setState({
            selectedProgram: data.selectedProgram,
          });
        }
        this.setState({
          ai: data,
          entryTerm: data.selectedEntryTerm, // ← keep the top-level copy in sync
        });
        const { errorAI } = this.state;
        const errorAIKeys = Object.keys(errorAI);
        if (errorAIKeys.length) {
          const returnValue = this.academicInterestCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[5] = 1;
            this.setState({ count: count });
          }
        }
        if (parseInt(data.selectedProgram) !== this.state.undergraduate) {
          this.setState({
            activeSections: [
              {
                name: "Personal Information",
                open: false,
              },
              {
                name: "Contact Details",
                open: false,
              },
              {
                name: "Family / Guardian Information",
                open: false,
              },
              {
                name: "Address",
                open: false,
              },
              {
                name: "Citizenship Information",
                open: false,
              },
              {
                name: "Program of Study",
                open: accordionValue,
              },
              {
                name: "Emergency Contact",
                open: false,
              },
              {
                name: "Education",
                open: false,
              },
              {
                name: "Test Scores",
                open: false,
              },
              {
                name: "Relationship with LGU",
                open: false,
              },
              {
                name: "Official Information in Arabic",
              },
              {
                name: "Motivation Letter",
                open: false,
              },
              {
                name: "Acknowledgement",
                open: false,
              },
            ],
            activeSections: [
              {
                name: "Personal Information",
                open: false,
              },
              {
                name: "Contact Details",
                open: false,
              },
              {
                name: "Family / Guardian Information",
                open: false,
              },
              {
                name: "Address",
                open: false,
              },
              {
                name: "Citizenship Information",
                open: false,
              },
              {
                name: "Program of Study",
                open: accordionValue,
              },
              {
                name: "Emergency Contact",
                open: false,
              },
              {
                name: "Education",
                open: false,
              },
              {
                name: "Test Scores",
                open: false,
              },
              {
                name: "Relationship with LGU",
                open: false,
              },
              {
                name: "Official Information in Arabic",
              },
              {
                name: "Motivation Letter",
                open: false,
              },
              {
                name: "Acknowledgement",
                open: false,
              },
            ],
          });
        } else {
          this.setState({
            activeSections: [
              {
                name: "Personal Information",
                open: false,
              },
              {
                name: "Contact Details",
                open: false,
              },
              {
                name: "Family / Guardian Information",
                open: false,
              },
              {
                name: "Address",
                open: false,
              },
              {
                name: "Citizenship Information",
                open: false,
              },
              {
                name: "Program of Study",
                open: accordionValue,
              },
              {
                name: "Emergency Contact",
                open: false,
              },
              {
                name: "Education",
                open: false,
              },
              {
                name: "Test Scores",
                open: false,
              },
              {
                name: "Relationship with LGU",
                open: false,
              },
              {
                name: "Official Information in Arabic",
              },
              {
                name: "Motivation Letter",
                open: false,
              },
              {
                name: "Acknowledgement",
                open: false,
              },
            ],
          });
        }
        break;
      case "GI":
        this.setState({ governmentInformation: data });
        const { errorGI } = this.state;
        const errorGIKeys = Object.keys(errorGI);
        if (errorGIKeys.length) {
          const returnValue = this.governmentInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[3] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Add":
        this.setState({ address: data });
        const { errorAdd } = this.state;
        const errorAddKeys = Object.keys(errorAdd);
        if (errorAddKeys.length) {
          const returnValue = this.addressCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[3] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Contact":
        this.setState({ contactInformations: data });
        const { errorContact } = this.state;
        let counts = 0;
        const errorMainKeys = Object.keys(errorContact);
        if (errorMainKeys.length) {
          const returnValue = this.contactCheck(data);
          for (const element in errorContact) {
            if (Object.prototype.hasOwnProperty.call(errorContact, element)) {
              const errorContactKeys = Object.keys(element);
              if (errorContactKeys.length) {
                if (returnValue !== 1) {
                  counts = 1;
                }
              }
            }
          }
          if (counts === 0) {
            const count = Array.from(this.state.count);
            count[1] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "PSI":
        this.setState({ parentsInformation: data });
        const { errorParent } = this.state;
        const errorParentKeys = Object.keys(errorParent);
        if (errorParentKeys.length) {
          const returnValue = this.parentsInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[2] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Guardian":
        this.setState({ guardianInformation: data });
        const { errorGuard } = this.state;
        const errorGuardKeys = Object.keys(errorGuard);
        if (errorGuardKeys.length) {
          const returnValue = this.guardianInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[6] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "TS":
        this.setState({ testScores: data });
        const { errorTest } = this.state;
        /* const errorTestkeys = Object.keys(errorTest) */
        if (errorTest.length) {
          const returnValue = this.testScoresCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[8] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "HI":
        this.setState({ healthInformation: data });
        const { errorHI } = this.state;
        const errorHIKeys = Object.keys(errorHI);
        if (errorHIKeys.length) {
          const returnValue = this.healthInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[9] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Sources":
        this.setState({ sourceInformation: data });
        const { errorSources } = this.state;
        const errorSourcesKeys = Object.keys(errorSources);
        if (errorSourcesKeys.length) {
          const returnValue = this.sourcesCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[9] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Policies":
        this.setState({ acceptedPolicies: data });
        break;
      default:
        break;
    }
  }

  toggleAccordion(index) {
    const { activeSections } = this.state;
    const sectionsBody = [];
    activeSections.forEach((section, i) => {
      if (i === index) {
        section.open = !section.open;
      } else {
        section.open = false;
      }
      sectionsBody.push(section);
    });
    this.setState({ activeSections: sectionsBody });
  }

  toggleAll() {
    const { activeSections } = this.state;
    const sectionsBody = [];
    activeSections.forEach((section, i) => {
      section.open = false;
      sectionsBody.push(section);
    });
    this.setState({ activeSections: sectionsBody });
  }

  getDefaultValue(componentName, data) {
    switch (componentName) {
      case "Add":
        this.setState({
          address: { ...this.state.address, addressType: data },
        });
        break;
      case "Contact":
        if (
          this.state.contactInformations &&
          this.state.contactInformations.phoneNumberArray &&
          this.state.contactInformations.phoneNumberArray.length > 0
        ) {
          const phoneNumberArray =
            this.state.contactInformations.phoneNumberArray;
          const length = phoneNumberArray.length;
          phoneNumberArray.forEach((element, i) => {
            if (i === length - 1) {
              element.phoneType = data;
            }
          });
          this.setState({
            contactInformations: {
              ...this.state.contactInformation,
              phoneNumberArray: phoneNumberArray,
            },
          });
        }
        break;
      case "Parent":
        if (
          this.state.parentsInformation &&
          this.state.parentsInformation.fatherPrefix &&
          this.state.parentsInformation.motherPrefix
        ) {
          this.setState({
            parentsInformation: {
              ...this.state.parentsInformation,
              fatherPrefix: data.fatherDefault,
              motherPrefix: data.motherDefault,
            },
          });
        }
        break;
      default:
        break;
    }
  }

  async handleSave() {
    const {
      letter,
      personalInformation,
      citizenshipInformation,
      officialArabicInformation,
      ai,
      governmentInformation,
      address,
      contactInformations,
      parentsInformation,
      guardianInformation,
      educationHistorys,
      healthInformation,
      sourceInformation,
      undergraduate,
      fatherId,
      motherId,
      testScores,
    } = this.state;
    const ci = [];
    if (
      contactInformations.phoneNumberArray &&
      contactInformations.phoneNumberArray.length > 0
    ) {
      contactInformations.phoneNumberArray.forEach((element) => {
        ci.push({
          PhoneType: element.phoneType,
          CountryId: element.phoneCountry,
          Email: contactInformations.email,
          PhoneNumber: element.phoneNumber,
          IsPrimary: element.isPrimary,
        });
      });
    }
    const eh = [];
    const errorCheck = ["", 0, null, undefined];
    if (educationHistorys) {
      if (
        [undergraduate, "", null, undefined, 0].indexOf(
          //parseInt(ai.selectedProgram)
          1
        ) === -1
      ) {
        if (
          false
          // educationHistorys.graduateDegree &&
          // educationHistorys.graduateDegree.length >= 1
        ) {
          educationHistorys.graduateDegree.forEach((element) => {
            eh.push({
              CurriculumId: element.universityCertificate,
              EndDate: element.yearOfGraduation,
              InstitutionId: element.universityName,
              InstitutionName: element.institutionName,
              CountryId: element.selectedCountry,
              CityId: element.selectedCity,
              GPA: element.gpa,
              EducationGrade: element.educationGrade,
            });
          });
        }
        if (
          errorCheck.indexOf(educationHistorys.universityCertificate) === -1 ||
          errorCheck.indexOf(educationHistorys.universityName) === -1 ||
          errorCheck.indexOf(educationHistorys.selectedCountry) === -1 ||
          errorCheck.indexOf(educationHistorys.yearOfGraduation) === -1 ||
          educationHistorys.gpa
        ) {
          eh.push({
            CurriculumId: educationHistorys.universityCertificate || "",
            EndDate: educationHistorys.yearOfGraduation || "",
            InstitutionId: educationHistorys.universityName || "",
            InstitutionName: educationHistorys.institutionName,
            CountryId: educationHistorys.selectedCountry || "",
            CityId: educationHistorys.selectedCity || "",
            GPA: educationHistorys.gpa || "",
            EducationGrade: educationHistorys.educationGrade || "",
          });
        }
      }
      //else if (parseInt(ai.selectedProgram) === undergraduate) {
      else if (true) {
        if (
          educationHistorys.underGradDegree &&
          educationHistorys.underGradDegree.length >= 1
        ) {
          educationHistorys.underGradDegree.forEach((element) => {
            eh.push({
              CurriculumId: element.highSchoolCertificate,
              StartDate: element.startDate,
              EndDate: element.endDate,
              InstitutionId: element.highSchoolName,
              SectionSpeciality: element.sectionSpeciality,
              InstitutionName: element.institutionName,
              CountryId: element.selectedCountry,
              CityId: element.selectedCity,
              TransferedInstitutionId: element.perviousUniversity,
              TransferedInstitutionName: element.perviousUniversityName,
              TransferredCerti: element.previousUniversityCertificate,
              TransferredGPA: element.previousUniversityGPA,
              EducationGrade: element.educationGrade,
              TransferCountryId: element.previousUniversityCountry,
              TransferCityId: element.previousUniversityCity,
            });
          });
        }
        if (
          errorCheck.indexOf(educationHistorys.highSchoolCertificate) === -1 ||
          errorCheck.indexOf(educationHistorys.highSchoolName) === -1 ||
          errorCheck.indexOf(educationHistorys.selectedCountry) === -1 ||
          errorCheck.indexOf(educationHistorys.perviousUniversity) === -1 ||
          errorCheck.indexOf(educationHistorys.endDate) === -1
        ) {
          eh.push({
            CurriculumId: educationHistorys.highSchoolCertificate,
            EndDate: educationHistorys.endDate,
            InstitutionId: educationHistorys.highSchoolName,
            InstitutionName: educationHistorys.institutionName,
            CountryId: educationHistorys.selectedCountry,
            CityId: educationHistorys.selectedCity,
            TransferedInstitutionId: educationHistorys.perviousUniversity,
            TransferedInstitutionName: educationHistorys.perviousUniversityName,
            TransferredCerti: educationHistorys.previousUniversityCertificate,
            TransferredGPA: educationHistorys.previousUniversityGPA,
            EducationGrade: educationHistorys.educationGrade,
            TransferCountryId: educationHistorys.previousUniversityCountry,
            TransferCityId: educationHistorys.previousUniversityCity,
          });
        }
      }
    }

    const sources = [];
    if (sourceInformation) {
      if (
        sourceInformation.selectedSources &&
        sourceInformation.selectedSources.length > 0
      ) {
        sourceInformation.selectedSources.forEach((element) => {
          sources.push({
            SourceId: element,
          });
        });
      }
    }
    const tests = [];
    if (testScores.tests && testScores.tests.length > 0) {
      testScores.tests.forEach((element) => {
        if (
          !(
            errorCheck.indexOf(element.test) !== -1 &&
            errorCheck.indexOf(element.testType) !== -1 &&
            errorCheck.indexOf(element.dateTaken) !== -1 &&
            !element.score
          )
        ) {
          tests.push({
            Test: element.test,
            TestType: element.testType,
            Score: element.score,
            DateTaken: element.dateTaken,
          });
        }
      });
    }
    // eslint-disable-next-line no-unused-vars
    const fetchBody = {
      Letter: letter?.letter || "",
      IncompleteApplicationId:
        this.props.incompleteApplicationId || sessionStorage.getItem("id"),
      // Personal Information
      FirstName: personalInformation.fName || "",
      MiddleName: personalInformation.mName || "",
      LastName: personalInformation.lName || "",
      Gender: personalInformation.selectedGender || "",

      DateOfBirth: personalInformation.dateOfBirth || "",
      CountryOfBirth: citizenshipInformation.selectedCountry || "",
      CityOfBirth: citizenshipInformation.cityOfBirth || "",
      Nationality: citizenshipInformation.selectedNationality || "",
      OtherNationality: citizenshipInformation.selectedOtherNationality || "",

      ArabicData: [
        {
          ColumnName: "ARABIC_FIRSTNAME",
          ColumnValue: officialArabicInformation.arabicText1 || "",
        },
        {
          ColumnName: "ARABIC_MIDDLENAME",
          ColumnValue: officialArabicInformation.arabicText2 || "",
        },
        {
          ColumnName: "ARABIC_LASTNAME",
          ColumnValue: officialArabicInformation.arabicText3 || "",
        },
        {
          ColumnName: "ARABIC_CIVIL_ID",
          ColumnValue: officialArabicInformation.arabicText4 || "",
        },
        {
          ColumnName: "ARABIC_CITY",
          ColumnValue: officialArabicInformation.arabicText5 || "",
        },
      ],
      // Program of Study
      ProgramOfStudyId: ai.selectedMajor || "",
      UniversityId: ai.selectedUniversity || "",
      ProgramId: ai.selectedProgram || "",
      PreferredCampus: ai.preferredCampus || "",
      EntryTerm: ai.selectedEntryTerm || "",
      Description: ai.description || "",
      Level: ai.selectedLevel || "",
      Language: ai.selectedLanguage || "",

      SecondUniversityId: ai.selectedSecondUniversity || "",
      SecondProgramId: ai.selectedSecondProgram || "",
      SecondMajorId: ai.selectedSecondMajor || "",
      SecondLanguage: ai.selectedSecondLanguage || "",
      SecDescription: ai.secondDescription || "",
      SecondLevel: ai.selectedSecondLevel || "",

      ThirdUniversityId: ai.selectedThirdUniversity || "",
      ThirdMajorId: ai.selectedThirdMajor || "",
      ThirdLanguage: ai.selectedThirdLanguage || "",
      // Government Information
      nationalIdNumber: governmentInformation.nationalNumber || "",
      passportNumber: governmentInformation.passportNumber || "",
      passportCountryIssued: governmentInformation.passportCountry || "",
      passportExpirationDate: governmentInformation.passportExpiryDate || "",
      // Address
      AddressTypeId: address.addressType || "",
      Line1: address.addressLine1 || "",
      Line2: address.addressLine2 || "",
      Country: address.selectedCountry || "",
      City: address.selectedCity || "",
      Region: address.selectedRegion || "",
      RegionInput: address.regionInput || "",
      DormPlanInterest: address.dormPlanInterest,
      // Contact
      ContactInformation: ci.length > 0 ? ci : null,
      // Parents Information
      FatherPrefix: parentsInformation.fatherPrefix || "",
      FatherRelationType: parentsInformation.fatherRelationship || "",
      FatherFirstName: parentsInformation.fatherFName || "",
      FatherMiddleName: parentsInformation.fatherMName || "",
      FatherFamilyName: parentsInformation.fatherLName || "",
      FatherProfession: parentsInformation.fatherProfession || "",
      FatherCompany: parentsInformation.fatherCompany || "",
      FatherCompanyAddress: parentsInformation.fatherCompanyAddress || "",
      FatherMobileNumber: parentsInformation.fatherPhone || "",
      FatherEmail: parentsInformation.fatherEmail || "",
      FatherAddress: parentsInformation.fatherAddress || "",
      FatherAttendedInstitution:
        parentsInformation.fatherAttendedInstitution || false,
      FatherDeceased: parentsInformation.fatherDeceased || false,
      IsFatherTKHEmployee: parentsInformation.isFatherEmployee || false,
      FatherIdNumber: parentsInformation.fatherIdNumber || "",
      MotherPrefix: parentsInformation.motherPrefix || "",
      MotherRelationType: parentsInformation.motherRelationship || "",
      MotherFirstName: parentsInformation.motherFName || "",
      MotherMiddleName: parentsInformation.motherMName || "",
      MotherFamilyName: parentsInformation.motherLName || "",
      MotherProfession: parentsInformation.motherProfession || "",
      MotherCompany: parentsInformation.motherCompany || "",
      MotherCompanyAddress: parentsInformation.motherCompanyAddress || "",
      MotherMobileNumber: parentsInformation.motherPhone || "",
      MotherEmail: parentsInformation.motherEmail || "",
      MotherAddress: parentsInformation.motherAddress || "",
      MotherAttendedInstitution:
        parentsInformation.motherAttendedInstitution || false,
      MotherDeceased: parentsInformation.motherDeceased || false,
      IsMotherTKHEmployee: parentsInformation.isMotherEmployee || false,
      MotherIdNumber: parentsInformation.motherIdNumber || "",
      // Guardian Information
      GuardianPrefix: guardianInformation.guardianPrefix || "",
      GuardianRelationType: guardianInformation.guardianRelationship || "",
      GuardianFirstName: guardianInformation.guardianFName || "",
      GuardianMiddleName: guardianInformation.guardianMName || "",
      GuardianFamilyName: guardianInformation.guardianLName || "",
      GuardianProfession: guardianInformation.guardianProfession || "",
      GuardianMobileNumber: guardianInformation.guardianPhone || "",
      GuardianEmail: guardianInformation.guardianEmail || "",
      GuardianAddress: guardianInformation.guardianAddress || "",
      // Education
      EducationHistory: eh.length > 0 ? eh : null,
      // Tests
      Tests: tests.length > 0 ? tests : null,
      // Health Information
      hasBeenIll: healthInformation.hasIllness || false,
      illnessDescription: healthInformation.illness || "",
      // Source Information
      SourcePrefix: sourceInformation.guardianPrefix || "",
      SourceRelationType: sourceInformation.guardianRelationship || "",
      SourceFirstName: sourceInformation.guardianFName || "",
      SourceFamilyName: sourceInformation.guardianLName || "",
      SourceMobileNumber: sourceInformation.guardianPhone || "",
      SourceEmail: sourceInformation.guardianEmail || "",
      SourceSuffix: sourceInformation.guardianSuffix || "",
      SourceInformation: sources.length > 0 ? sources : null,
      OtherSource: sourceInformation ? sourceInformation.otherSource : null,
    };

    return fetch(`${process.env.REACT_APP_API_URL}/api/Save/SaveApplication`, {
      method: "POST",
      body: JSON.stringify(fetchBody),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200) {
          this.setState({ saveProcessing: false });
          sessionStorage.setItem("isBlocking", false);
          return 1;
        } else {
          this.setState({ saveProcessing: false });
          this.setState({ policyError: "Some Error Occured!", color: "red" });
          return 0;
        }
      })
      .catch((err) => {
        this.setState({ saveProcessing: false });
        console.log(err);
        this.setState({ policyError: "Some Error Occured", color: "red" });
      });
  }

  async submit() {
    this.setState({ nextProcessing: true });
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/Validate/ValidateApplication`,
      {
        method: "POST",
        body: JSON.stringify({
          IncompleteApplicationId:
            this.props.incompleteApplicationId || sessionStorage.getItem("id"),
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200) {
          this.props.onSubmit();
          this.setState({ nextProcessing: false });
        } else if (res.StatusCode === 404) {
          this.setState({ nextProcessing: false });
          const error = [];
          if (res.Msg.ProgramOfStudyId || res.Msg.ProgramId) {
            this.setState({
              errorAI: {
                selectedMajor: res.Msg.ProgramOfStudyId
                  ? "Please check this value"
                  : null,
                selectedProgram: res.Msg.ProgramId
                  ? "Please check this value"
                  : null,
              },
            });
            error.push("Program of Study");
          }
          if (res.Msg.GovernmentId) {
            this.setState({
              errorGI: { nationalNumber: "Please Enter the value" },
            });
            error.push("Official Identification");
          }

          if (res.Msg.AddressTypeId) {
            this.setState({
              errorAdd: { addressType: "Please select a value" },
            });
            error.push("Address");
          }

          if (res.Msg.TestType) {
            this.setState({
              errorTest: {
                TestType: "Please select all test type for the selected test",
              },
            });
            error.push("English Proficiency Assessment : ");
          }

          if (res.Msg.ExistsTestType) {
            this.setState({
              testTypeError:
                `English Proficiency Assessment :` + res.Msg.ExistsTestType,
              color: "red",
            });
          }
          this.setState({
            policyError: `${error.join(
              ", "
            )} Please enter all test type for the choosen test(s).`,
            color: "red",
          });
          // this.setState({ policyError: `${error.join(', ')} section(s) have error(s) in them.`, color: 'red' })
          this.conditionCheck();
        }
      })
      .catch((err) => {
        this.setState({ nextProcessing: false });
        console.log(err);
      });
  }

  render() {
    const {
      error,
      policyError,
      testTypeError,
      loading,
      color,
      acceptedPolicies,
      saved,
      activeSections,
      count,
      saveProcessing,
      nextProcessing,
      isPopup,
    } = this.state;
    if (loading) {
      return (
        <div id="mainContainer">
          <div id="designBorder">
            <div
              id="main-page"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={loader}
                style={{
                  justifyContent: "center",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                alt="Loading..."
              />
            </div>
          </div>
        </div>
      );
    }
    if (error) {
      return (
        <div id="mainContainer">
          <div id="designBorder">
            <div id="main-page">
              <p style={{ color: "red", maxWidth: "calc(100% - 150px)" }}>
                {error}
              </p>
              {/* <button
                className="save"
                onClick={() => this.props.onClick()}
                id="logout-button"
              >
                Logout
              </button> */}
            </div>
          </div>
        </div>
      );
    }
    const accordionSections = [];
    activeSections.forEach((element, i) => {
      if (activeSections.length === 12 && i >= 9) {
        accordionSections.push(
          <div key={i}>
            <div
              className={"accordion " + (element.open ? "open" : "")}
              key={i}
            >
              <div
                className="accordionSectionHeader"
                onClick={() => this.toggleAccordion(i)}
              >
                <span
                  className="accordionSectionHeaderContent"
                  style={
                    count[i] === 0
                      ? {
                          backgroundColor: "white",
                          color: "red",
                          borderWidth: 1,
                          borderColor: "red",
                          borderStyle: "solid",
                          boxSizing: "border-box",
                        }
                      : null
                  }
                >
                  {count[i] === 0 ? "!" : `${i + 1}`}
                </span>
                <span
                  className="acc-heading"
                  style={count[i] === 0 ? { color: "red" } : null}
                >
                  {element.name}
                </span>
              </div>
              <div className="accordion-form">{this.getActiveTabBody(i)}</div>
            </div>
          </div>
        );
      } else {
        accordionSections.push(
          <div key={i}>
            <div
              className={"accordion " + (element.open ? "open" : "")}
              key={i}
            >
              <div
                className="accordionSectionHeader"
                onClick={() => this.toggleAccordion(i)}
              >
                <span
                  className="accordionSectionHeaderContent"
                  style={
                    count[i] === 0
                      ? {
                          backgroundColor: "white",
                          color: "red",
                          borderWidth: 1,
                          borderColor: "red",
                          borderStyle: "solid",
                          boxSizing: "border-box",
                        }
                      : null
                  }
                >
                  {count[i] === 0 ? "!" : `${i + 1}`}
                </span>
                <span
                  className="acc-heading"
                  style={count[i] === 0 ? { color: "red" } : null}
                >
                  {element.name}
                </span>
              </div>
              <div className="accordion-form">{this.getActiveTabBody(i)}</div>
            </div>
          </div>
        );
      }
    });
    return (
      <>
        {saved ? (
          <div className="alert-box">
            <div className="alert-box-header">
              <p>Application Saved</p>
              <p
                onClick={() => this.setState({ saved: false })}
                style={{ cursor: "pointer" }}
              >
                X
              </p>
            </div>
            <div className="alert-box-body">
              <p>Your application has been saved</p>
            </div>
            <div className="alert-box-footer">
              <button
                className="save"
                onClick={() => {
                  this.setState({ saved: true });
                  this.props.onClick();
                }}
              >
                Ok
              </button>
            </div>
          </div>
        ) : null}
        {isPopup ? (
          <div className="alert-box-discliamer">
            <div className="alert-box-header">
              <p>Please Read the Below Disclaimers</p>
              <p
                onClick={() => {
                  this.setState({ isPopup: false });
                }}
                style={{ cursor: "pointer" }}
              >
                X
              </p>
            </div>
            <div className="alert-box-body">
              <p>
                o Please note that TKH New Zayed Campus <b>is due to</b> operate
                starting the second semester of 23/24 Academic Year.
                <br />o Students joining the New Zayed Campus will attend the
                first semester of the 23/24 Academic Year in The New
                Administrative Capital’s Campus and the second semester at The
                New Zayed Campus.
              </p>
            </div>
            <div className="alert-box-footer">
              <button
                className="save"
                onClick={() => {
                  this.setState({ isPopup: false });
                }}
              >
                Ok
              </button>
            </div>
          </div>
        ) : null}
        <div id={saved || isPopup ? "mainContainer-blur" : "mainContainer"}>
          <div id="designBorder">
            <img src={logo} className="center main-logo"></img>
            <div id="main-page">
              <div id="applicationForm">
                <h4 className="app-heading">
                  LGU Application Form for Undergraduate Studies
                </h4>
                <p style={{ fontWeight: "bold" }}>Application Instructions:</p>
                {/* <button
                  className="save"
                  onClick={() => {
                    if (sessionStorage.getItem("isBlocking") === "false") {
                      this.props.onClick();
                    } else {
                      // alert('Please save your data before exiting.')
                      this.handleSave();
                      this.props.onClick();
                      sessionStorage.setItem("isBlocking", false);
                    }
                  }}
                  id="logout-button"
                >
                  Logout
                </button> */}
                <div id="header">
                  <p className="main-content-list">
                    {" "}
                    • You may save your application and return to complete it at
                    any time. However, once submitted, your application can no
                    longer be accessed, edited, or modified. Please review it
                    carefully before final submission.
                  </p>

                  <p className="main-content-list">
                    {" "}
                    • The email address and mobile number used to create your
                    account will serve as our primary means of communication
                    throughout the admission process. Ensure that both are
                    entered accurately and remain active.
                  </p>

                  {/* <p className="main-content-list">
                    {" "}
                    • Select the degree and specify your course of interest,
                    with a maximum of three choices.
                  </p>

                  <p className="main-content-list">
                    • Please note that the Admission Committee will be
                    conducting the screening process based on your First Choice
                    of University, Degree, and Programme only. If your
                    enrollment into your First Choice of University, Degree, and
                    Programme has been rejected by the Admissions Committee,
                    your Second Choice of the University will be taken into
                    consideration during the screening process.
                  </p> */}

                  {/* <p className="main-content-list">
                    • Please note that there is a 1,200 LE application fee to be
                    paid online while submitting your application
                  </p> */}

                  {/* <p className="main-content-list">
                    • Please ensure to read all TKH Online Application
                    Guidelines before submitting on this
                    <td
                      style={{ color: "#3168cd", textDecoration: "underline" }}
                      onClick={() =>
                        window.open(
                          "https://tkh.edu.eg/how-to-apply/",
                          "_blank"
                        )
                      }
                    >
                      webpage
                    </td>{" "}
                  </p> */}
                </div>
              </div>
              <br />
              {policyError && <p style={{ color: color }}>{policyError}</p>}
              {testTypeError && <p style={{ color: color }}>{testTypeError}</p>}
              {accordionSections}
              <div className="main-button">
                <button
                  className="save"
                  onClick={() => {
                    this.setState({ saveProcessing: true });
                    this.toggleAll();
                    this.setState({ policyError: "" });
                    this.setState({ testTypeError: "" });
                    this.handleSave().then((res) => {
                      if (res === 1) {
                        this.setState({ saved: true });
                      }
                    });
                  }}
                  disabled={saveProcessing}
                >
                  {saveProcessing ? (
                    <img
                      src={submit}
                      alt="Loading..."
                      style={{ width: 18, height: 18 }}
                    />
                  ) : (
                    "Save and Exit"
                  )}
                </button>
                <button
                  className="save"
                  onClick={() => {
                    this.setState({ nextProcessing: true });
                    this.setState({ policyError: "" });
                    this.setState({ testTypeError: "" });
                    const count = this.conditionCheck();
                    if (count.indexOf(0) === -1) {
                      this.handleSave().then((res) => {
                        if (res === 1) {
                          this.submit();
                        } else {
                          this.setState({ nextProcessing: false });
                        }
                      });
                    } else {
                      this.setState({ nextProcessing: false });
                    }
                  }}
                  disabled={!acceptedPolicies || nextProcessing}
                >
                  {nextProcessing ? (
                    <img
                      src={submit}
                      alt="Loading..."
                      style={{ width: 18, height: 18 }}
                    />
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
Mains.propTypes = {
  incompleteApplicationId: PropTypes.number,
  token: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  history: PropTypes.object,
};
